if (!ACC) {
    var ACC = {};
}
if (!ACC.productMiterSawing) {
    ACC.productMiterSawing = {};
}

if (!ACC.processing) {
	ACC.processing = {};
}

ACC.productMiterSawing.MITER_DATA_VALID = 0;
ACC.productMiterSawing.ERR_MITER_LENGTH_INVALID = 1;
ACC.productMiterSawing.ERR_MITER_LENGTH_RANGE = 2;
ACC.productMiterSawing.ERR_MITER_MISSING_TYPE = 10;
ACC.productMiterSawing.ERR_MITER_ANGLE_A_INVALID = 11;
ACC.productMiterSawing.ERR_MITER_ANGLE_B_INVALID = 12;
ACC.productMiterSawing.ERR_MITER_ANGLE_A_RANGE = 13;
ACC.productMiterSawing.ERR_MITER_ANGLE_B_RANGE = 14;

ACC.productMiterSawing.dimensionTableCustomVariant = $("#dimension-table .custom-variant");

ACC.productMiterSawing.setMiterSawing = function() {
    ACC.productMiterSawing.dimensionTableCustomVariant.on("click", function(e){
        e.preventDefault();
        var wrapper = $('.custom-dimension-miter-wrapper');
        if (wrapper.hasClass("miter-variant") || wrapper.hasClass("dkg-miter-variant")) {

            if (!$(this).hasClass("not-active") &&
                ($(this).attr('data-state') == "orderable" || $(this).attr('data-state') == "disabled") &&
                !$(this).hasClass('custom-variant-selection') &&
                !wrapper.find('.custom-dimension-miter-input-popup').hasClass('open')
            ) {
                var miterSawingVariantCode = $('#miterSawingVariant').val();

                // check, if there is a variant product for miter sawing
                if (miterSawingVariantCode.length > 0) {
                    var url = ACC.productMiterSawing.sawingUrl + "/" + miterSawingVariantCode;
                    $.ajax({
                        url: url,
                        type: "GET",
                        async: false,
                        success: function (data) {

                            // remove old jcarousel container and create a new one
                            $('div.miter-forms').remove();
                            $('.miter-body').prepend('<div class="miter-forms"><ul id="miterCarousel" class="jcarousel-skin-miter"></ul></div>');

                            ACC.productMiterSawing.prepareMiterSawingPopup(data);
                            ACC.productMiterSawing.callMiterSawingColorBox('init');

                        },
                        error: function () {
                        }
                    });
                } else {
                    // remove old jcarousel container and create a new one
                    $('div.miter-forms').remove();
                    $('.miter-body').prepend('<div class="miter-forms"><ul id="miterCarousel" class="jcarousel-skin-miter"></ul></div>');
                    ACC.productMiterSawing.prepareMiterSawingPopup();
                    ACC.productMiterSawing.callMiterSawingColorBox('init');
                }
            }

            if (!$(this).hasClass("not-active") &&
                ($(this).attr('data-state') == "selected") &&
                 !$('.custom-dimension-miter-wrapper').find('.custom-dimension-miter-input-popup').hasClass('open')) {
                // deselect miter sawing
                ACC.productMiterSawing.resetCustomMiterDimension();
                ACC.productMiterSawing.hideMiterSawingDataOnPDP();
                $(".qty_block .no-variant-wrapper").removeClass('no-pointer');

                if (typeof resetQuantity !== "undefined") {
                    resetQuantity();
                }

                callVariantResource(ACC.productDetail.getAllDimensionCodes());
            }
        }
    });

    // miter-header: fixed angle
    $('#fixedLengthButton').on("click", function () {
        var fixLenBtn = $('#fixedLengthButton');
        var mitSawBtn = $('#miterSawingButton');

        if (fixLenBtn.attr('data-miter-btn-state') == "orderable"  || fixLenBtn.hasClass('orderable')) {
            // manage buttons in miter-header
            mitSawBtn.attr('data-miter-btn-state', 'orderable');
            mitSawBtn.removeClass('selected').addClass('orderable');
            fixLenBtn.attr('data-miter-btn-state', 'selected');
            fixLenBtn.removeClass('orderable').addClass('selected');

            // hide miter-sawing popup elements
            $('.miter-forms').addClass('hide');
            $('.miter-form-error.help-inline').addClass('hide');
            if ($('.miter-tolerance').length) {
                $('.miter-tolerance').removeClass('hide');
            }else {
                $('.miter-tolerance').addClass('hide');
            }
            $('.miter-angle-1').addClass('hide');
            $('.miter-angle-2').addClass('hide');
            $('.miter-angle-3').addClass('hide');
            $('.miter-angle-4').addClass('hide');
            $('.miter-form-name').addClass('hide');
            $('.miter-form-image').addClass('hide');

            $.colorbox.resize();
        }
    });

    // miter-header: custom angle
    $('#miterSawingButton').on("click", function () {
        var mitSawBtn = $('#miterSawingButton');
        var fixLenBtn = $('#fixedLengthButton');

        if (mitSawBtn.attr('data-miter-btn-state') == "orderable" || mitSawBtn.hasClass('orderable')) {
            // manage buttons in miter-header
            fixLenBtn.attr('data-miter-btn-state', 'orderable');
            fixLenBtn.removeClass('selected').addClass('orderable');
            mitSawBtn.attr('data-miter-btn-state', 'selected');
            mitSawBtn.removeClass('orderable').addClass('selected');

            // show miter-sawing popup elements
            $('.miter-forms').removeClass('hide');

            // dragable containment can be red now after positioning of elements
            ACC.productMiterSawing.initMiterFormCarousel();

            if ($('.miter-tolerance').length) {
                $('.miter-tolerance').removeClass('hide');
            } else {
                $('.miter-tolerance').addClass('hide');
            }

            if ($('#miterCarousel .miter-form.selected').length > 0) {
                // one miter form is selected
                var angleCount = $('#miterCarousel .miter-form.selected').attr('data-angle-count');
            	if (angleCount == "1" || $('#miterCarousel .miter-form.selected').attr('data-angle-1') == "true") {
                    $('.miter-angle-1').removeClass('hide');
                }
                if (angleCount == "2" || $('#miterCarousel .miter-form.selected').attr('data-angle-2') == "true") {
                    $('.miter-angle-2').removeClass('hide');
                }
                if (angleCount == "3" || $('#miterCarousel .miter-form.selected').attr('data-angle-3') == "true") {
                    $('.miter-angle-3').removeClass('hide');
                }
                if (angleCount == "4" || $('#miterCarousel .miter-form.selected').attr('data-angle-4') == "true") {
                    $('.miter-angle-4').removeClass('hide');
                }

                $('.miter-form-name').removeClass('hide');
                $('.miter-form-image').removeClass('hide');
            } else {
                $('.miter-angle-1').addClass('hide');
                $('.miter-angle-2').addClass('hide');
                $('.miter-angle-3').addClass('hide');
                $('.miter-angle-4').addClass('hide');
                $('.miter-form-name').addClass('hide');
                $('.miter-form-image').addClass('hide');
            }

            $.colorbox.resize();
        }
    });

    // Cancel button in popup
    $('.custom-dimension-miter-wrapper .custom-dimension-input-popup_cancel').on('click', function (e) {
        e.preventDefault();

        ACC.productMiterSawing.hideMiterSawingPopup();
        $.colorbox.close();
    });

    // ready button in popup
    $('#dimension-table .send-miter-sawing-data').on("click",function(e){
        e.preventDefault();
        ACC.productMiterSawing.submitMiterSawing();
        
        ACC.productDetail.setDimensionResetState();
    });

    $('.show-miter-custom-data .miter-change-link').on("click", function (e) {
        e.preventDefault();

        ACC.productMiterSawing.callMiterSawingColorBox('change');
    });
};

ACC.productMiterSawing.submitMiterSawing = function() {
    var isValid = ACC.productMiterSawing.validateMiterPopup();
    if (isValid) {
        // set miter sawing data in add to cart form
        $("#sawingTolerance").val($('.miter-tolerance .custom-dimension-tolerance-select').val());
        $('#customLength').val($(".input-miter-length").val());
        if ($("#miterSawingButton").attr('data-miter-btn-state') == 'selected') {
            $("#sawingType").val('MITER');
            $("#sawingCode").val( $('#miterCarousel .miter-form.selected').attr('data-sawing-type'));
            // dkg only
            $("#processingId").val( $('#miterCarousel .miter-form.selected').attr('data-sawing-type'));
            $("#sawingAngleA").val($('.miter-angle-1 .input-miter-angle').val());
            if ($('#miterCarousel .miter-form.selected').attr('data-angle-count') == "1") {
                $("#sawingAngleB").val("");
            } else {
                $("#sawingAngleB").val($('.miter-angle-2 .input-miter-angle').val());
            }
        } else {
            $("#sawingType").val('DEGREE_90');
            $("#sawingCode").val("");
            $("#sawingAngleA").val("");
            $("#sawingAngleB").val("");
        }
        callVariantResource(ACC.productDetail.getAllDimensionCodes());
        if ($('#qtyInput').val() > 0) {
            quantityChange();
        }
    }
};

ACC.productMiterSawing.handleMiterPopupResponse = function(isSuccess) {
    var $customDimensionMiterInputPopup = $(".custom-dimension-miter-input-popup");
    if(!$("#sawingType").val() || !$('#miterSawingVariant').val()) return;
    if(isSuccess){
        // hide popup and prepare addToCart/quantity
        unselectAll($(".dimension-count-for-custom-dimension").val());
        $(".custom-dimension-miter-wrapper .custom-dimension-minmax-popup").addClass("hide");

        $('#qtyInput').prop("disabled", false);
        $('.input-miter-length').removeClass("dimension-input-border");
        ACC.productMiterSawing.dimensionTableCustomVariant.addClass("custom-variant-selection").attr('data-state',"selected");
        $('.reset-icon').removeClass("hide");
        $('.custom-dimension-miter-wrapper').addClass("hide");
        $('.custom-dimension-miter-input-popup').addClass("hide");
        $('.custom-dimension-miter-wrapper').find('.custom-dimension-miter-input-popup').removeClass('open');
        if ($("#miterSawingButton").attr('data-miter-btn-state') == 'selected') {
            // set miter sawing data in addToCart form
            ACC.productMiterSawing.updatePageInfos();

            // show miter sawing data on pdp
            $('.show-miter-form-name .value').text($('.miter-form-name h3').text());
            $('.show-miter-form-image .value').html($('.miter-form-image').html());
        } else {
            ACC.productMiterSawing.dimensionTableCustomVariant.find('.value').text($('.input-miter-length').val());
            $('.show-miter-custom-data').addClass('hide');
        }
        $.colorbox.close();
    } else {
        $customDimensionMiterInputPopup.find(".help-inline").removeClass("hide");
        $customDimensionMiterInputPopup.find(".custom-dimension-response-error-popup").removeClass("hide");
        $('#customLength').val("");
    }
};

ACC.productMiterSawing.updatePageInfos = function() {
    ACC.productMiterSawing.dimensionTableCustomVariant.find('.value').text(ACC.productMiterSawing.dimensionTableCustomVariant.attr('data-selected-text'));
    $('.show-miter-length .value').text($('.input-miter-length').val());
    $('.show-miter-tolerance .value').text($('.miter-tolerance .custom-dimension-tolerance-select').val());
    $('.show-miter-angle-1 .value').html($('.miter-angle-1 .input-miter-angle').val());

    if ($('.miter-angle-2 .input-miter-angle').val().length > 0 && $('.miter-angle-2 .input-miter-angle').val() != "0&deg;") {
        $('.show-miter-angle-2 .value').html($('.miter-angle-2 .input-miter-angle').val());
        $('.show-miter-angle-2').removeClass('hide');
    } else {
        $('.show-miter-angle-2 .value').text("");
        $('.show-miter-angle-2').addClass('hide');
    }
    $('.show-miter-custom-data').removeClass('hide');
};

ACC.productMiterSawing.initMiterFormCarousel = function(){
    var $list = $('#miterCarousel');
    if (!$list.length) {
        return;
    }

    // correct position for only one element
    $list.css('top', 0);

    var $listParent = $list.parent();
    var parentHeight = $listParent.outerHeight();
    var itemCount = $list.find('li').length;
    var $lastItem = $list.find('li').last();
    var listHeight = $lastItem.position().top + $lastItem.outerHeight();
    var itemHeight = $lastItem.position().top /  (itemCount - 1);

    // take over scrolling since functionality doesn't work together with dragging
    var carousel = $list.data('jcarousel');
    carousel.prev = function(){
        if(!carousel.locked){
            var pos = Math.abs($list.position().top / itemHeight);
            pos = Math.max(pos - 1, 0);
            carousel.locked = true;
            $list.animate({'top': -(pos * itemHeight)}, 500, carousel.afterAnimation);
        }
    };
    carousel.next = function(){
        if(!carousel.locked){
            var pos = Math.abs($list.position().top / itemHeight);
            pos = Math.min(pos + 1, itemCount - 1);
            carousel.locked = true;
            $list.animate({'top': -(Math.min(pos * itemHeight, listHeight - parentHeight))}, 500, carousel.afterAnimation);
        }
    };
    carousel.buttonPrev.unbind('click');
    carousel.buttonPrev.bind('click', carousel.prev);
    carousel.buttonNext.unbind('click');
    carousel.buttonNext.bind('click',carousel.next);
    carousel.afterAnimation = function() {
        carousel.buttonPrev[$list.position().top < 0 ? 'removeAttr' : 'attr']('disabled', 'disabled');
        var minTop = -(listHeight - parentHeight);
        // respect 1px animate threshold
        carousel.buttonNext[($list.position().top - minTop) > 1 ? 'removeAttr' : 'attr']('disabled', 'disabled');
        carousel.locked = false;
    };
    carousel.afterAnimation();

    // mousewheel
    if(listHeight > parentHeight) {
        //FF doesn't recognize mousewheel as of FF3.x
        var mouseWheelEvent=(/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";
        $list.bind(mouseWheelEvent, function(event) {
            if (event.originalEvent.detail < 0 || event.originalEvent.wheelDelta > 0) {
                carousel.prev();
            } else {
                carousel.next();
            }
            event.preventDefault();
            return false;
        });
    }

    // draggable
    // can only calculate containment correct, when visible
    // http://jsfiddle.net/rachit_doshi/FhNtt/3/
    var containmentY2 = $listParent.offset().top;
    var containmentY1 = containmentY2 - listHeight + parentHeight;
    $list.draggable({
        axis: "y",
        distance: 10,
        containment:  [0, containmentY1, 0, containmentY2],
        stop: carousel.afterAnimation
    });
};

ACC.productMiterSawing.addMiterForm = function (element, index, ar) {
    var html = '<li><a href="#" class="miter-form" data-angle-count="' + element.angles + '" data-sawing-type="' + element.type + '">' +
        '<div class="miter-form-thumb"><img src="' + element.imgUrl + '"></div>' +
        '<div class="miter-form-type"><span>Typ: ' + element.type + '</span></div>' +
        '</a></li>';

    jQuery('#miterCarousel').append(html);
};

ACC.productMiterSawing.addDkgMiterForm = function() {
    var html = $('#dkgMiterCarouselContentContainer').html();
    jQuery('#miterCarousel').append(html);
};

ACC.productMiterSawing.resetCustomMiterDimension = function(){
    // restore custom field data
    ACC.productMiterSawing.dimensionTableCustomVariant.attr('data-state',"orderable");
    ACC.productMiterSawing.dimensionTableCustomVariant.removeClass("custom-variant-selection");
    ACC.productMiterSawing.dimensionTableCustomVariant.find('.value').text(ACC.productMiterSawing.dimensionTableCustomVariant.attr('data-placeholder'));

    // show fixed length button
    $('#fixedLengthButton').attr('data-miter-btn-state', 'selected');
    $('#fixedLengthButton').removeClass('orderable').addClass('selected');

    $('#miterSawingButton').attr('data-miter-btn-state', 'orderable');
    $('#miterSawingButton').removeClass('selected disabled').addClass('orderable');

    // remove addToCart form fields
    $("#sawingType").val("");
    $("#sawingCode").val("");
    $("#sawingAngleA").val("");
    $("#sawingAngleB").val("");
    $('#customLength').val("");
    $('#sawingTolerance').val("");

    // reset input fields
    $('.input-miter-angle').val('');
    $('.input-miter-length').val('');
    $('.miter-tolerance .custom-dimension-tolerance-select').val($('.miter-tolerance .custom-dimension-tolerance-select option').first().val());

    // hide miter popup elements
    $('.reset-icon').addClass("hide");
    $('.miter-forms').addClass('hide');
    if ($('.miter-tolerance').length) {
        $('.miter-tolerance').removeClass('hide');
    }else {
        $('.miter-tolerance').addClass('hide');
    }
    $('.miter-angle-1').addClass('hide');
    $('.miter-angle-2').addClass('hide');
    $('.miter-angle-4').addClass('hide');
    $('.miter-angle-3').addClass('hide');
    $('.miter-form-name').addClass('hide');
    $('.miter-form-image').addClass('hide');

    // addToCart handling
};

ACC.productMiterSawing.loadMiterData = function () {
    var $sawingCode = "";
	var length;
	var angle1;
	var angle2;
	var angle3;
	var angle4;
	var sawingTolerance;
	
    if ($('.custom-dimension-miter-wrapper.dkg-miter-variant').length) {
        // DKG only
        length = $("#processingLength").val();
        angle1 = $('#processingAngleA').val();
        angle2 = $('#processingAngleB').val();
        angle3 = $('#processingAngleC').val();
        angle4 = $('#processingAngleD').val();
        $sawingCode = $('#processingId').val();
    } else {
        length = $("#customLength").val();
        sawingTolerance = $("#sawingTolerance").val();
        angle1 = $('#sawingAngleA').val();
        angle2 = $('#sawingAngleB').val();
        angle3 = $('#sawingAngleC').val();
        angle4 = $('#sawingAngleD').val();
        $sawingCode = $('#sawingCode').val();

    }
	var miterFormString = ".miter-forms .miter-form" + "[data-sawing-type='" + $sawingCode + "']";
	ACC.productMiterSawing.selectSawingType(miterFormString, length, angle1, angle2, angle3, angle4, sawingTolerance);
};

ACC.productMiterSawing.selectSawingType = function (miterFormString, length, angle1, angle2, angle3, angle4, sawingTolerance) {
	$('.miter-forms .miter-form').removeClass('selected');
    $(miterFormString).click(); // we use click() instead of addClass("selected"), because for some reason, some of the input fields for the angles were not rendered in some cases (EC-2059)
	$('.input-miter-length').val(length);
	$('.miter-angle-1 .input-miter-angle').val(angle1);
	$('.miter-angle-2 .input-miter-angle').val(angle2);
	$('.miter-angle-3 .input-miter-angle').val(angle3);
	$('.miter-angle-4 .input-miter-angle').val(angle4);
	if (sawingTolerance) {
		$('.miter-tolerance .custom-dimension-tolerance-select').val(sawingTolerance);
	}
};

ACC.productMiterSawing.showMiterPopup = function (state) {
    ACC.productMiterSawing.resetValidationMessages();

    if (state == 'change') {
        ACC.productMiterSawing.loadMiterData();
        // show miter sawing button
        $('#fixedLengthButton').attr('data-miter-btn-state', 'orderable');
        $('#fixedLengthButton').removeClass('selected disabled').addClass('orderable');

        $('#miterSawingButton').attr('data-miter-btn-state', 'selected');
        $('#miterSawingButton').removeClass('orderable disabled').addClass('selected');

        $('.miter-forms').removeClass('hide');
        $('.miter-tolerance').removeClass('hide');

        var angleCount = $('#miterCarousel .miter-form.selected').attr('data-angle-count');
        if (angleCount == "1") {
            $('.miter-angle-1').removeClass('hide');
            $('.miter-angle-2 .input-miter-angle').val('');
            $('.miter-angle-2').addClass('hide');
        } else if (angleCount == "2") {
            $('.miter-angle-2').removeClass('hide');
        }
        $('.miter-form-name').removeClass('hide');
        $('.miter-form-image').removeClass('hide');
    }

    $('.custom-dimension-miter-wrapper').removeClass("hide");
    $('.custom-dimension-miter-wrapper').find('.custom-dimension-miter-input-popup').removeClass("hide");//.css("left", -popupWidth + linkWidth);
    $('.custom-dimension-miter-wrapper').find('.custom-dimension-miter-input-popup').addClass('open');
    $('.custom-dimension-miter-wrapper').find('.custom-dimension-miter-input-popup').find('.input-miter-length').select();
};

ACC.productMiterSawing.hideMiterSawingDataOnPDP = function() {
    if (!$('.dkg-custom-variant').length) {
        $('.show-miter-custom-data').addClass('hide');
    }
};

ACC.productMiterSawing.hideMiterSawingPopup = function() {
    $('.custom-dimension-miter-wrapper').addClass("hide");
    $('.custom-dimension-miter-input-popup').removeClass('open');
    $('.custom-dimension-miter-input-popup').addClass("hide");
};

// ============================== Section: Validation ==============================
ACC.productMiterSawing.resetValidationMessages = function() {
    $('.custom-dimension-miter-wrapper .help-inline').addClass('hide');
    $('.custom-dimension-miter-wrapper .help-inline span').addClass('hide');
    $('.input-miter-length').removeClass('dimension-input-border');
    $('.input-miter-angle').removeClass('dimension-input-border');
};

// used in validateMiterPopup
ACC.productMiterSawing.validateMiterLength = function ($input, $angle1, $angle2, $miterSawingType) {
    var result = "";
    var sawingType = ($('#miterSawingButton').attr('data-miter-btn-state') == "selected") ? "MITER" : "DEGREE_90";
    $.ajax({
        async: false,
        type: "POST",
        dataType: 'json',
        contentType: 'application/json',
        url: $('.send-miter-sawing-data').data('url'),
        data: JSON.stringify({
            sawingLength: $input.val(),
            sawingType: sawingType,
            selectionCodes: ACC.productDetail.getAllDimensionCodes(),
            selectionValues: ACC.productDetail.getSelectedVariantValues(),
            mitersawingOptions: {
                type: $miterSawingType,
                angleA: $angle1.val(),
                angleB: $angle2.val()
            }
        }),
        success: function (data, status) {
            result = data.errorcode;
        }
    });

    return result;
};

ACC.productMiterSawing.validateMiterPopup = function() {
    var popupIsValid = true;
    var $inputMiterLength = $('.custom-dimension-miter-wrapper .input-miter-length');
    var $inputMiterAngle1 = $('.custom-dimension-miter-wrapper .miter-angle-1 .input-miter-angle');
    var $inputMiterAngle2 = $('.custom-dimension-miter-wrapper .miter-angle-2 .input-miter-angle');
    var $mitersawingType = $('#miterCarousel .miter-form.selected').attr('data-sawing-type');

    // remove all old validation errors
    $('.custom-dimension-miter-wrapper .help-inline').addClass("hide");
    $('.custom-dimension-miter-wrapper .help-inline span').addClass("hide");
    $('.miter-angle-1 .help-inline').addClass("hide");
    $('.miter-angle-2 .help-inline').addClass("hide");
    $inputMiterLength.removeClass("dimension-input-border");
    $inputMiterAngle1.removeClass("dimension-input-border");
    $inputMiterAngle2.removeClass("dimension-input-border");

    // ---------- validate miter length ------------------------------
    var result = ACC.productMiterSawing.validateMiterLength($inputMiterLength, $inputMiterAngle1, $inputMiterAngle2, $mitersawingType);

    if (result > 0) {
        popupIsValid = false;
    }
    switch (result) {
        case ACC.productMiterSawing.ERR_MITER_LENGTH_INVALID :
            $('.miter-length .help-inline').removeClass("hide");
            $inputMiterLength.addClass("dimension-input-border");
            $('.miter-length .help-inline .miter-validation-angle-invalid-error').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_LENGTH_RANGE :
            $('.miter-length .help-inline').removeClass("hide");
            $inputMiterLength.addClass("dimension-input-border");
            $('.miter-length .help-inline .miter-validation-length-minmax-error').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_MISSING_TYPE :
            $('.miter-form-error.help-inline').removeClass("hide");
            $('.miter-form-error.help-inline .custom-dimension-miterform-popup').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_ANGLE_A_INVALID:
            $('.miter-angle-1 .help-inline').removeClass("hide");
            $inputMiterAngle1.addClass("dimension-input-border");
            $('.miter-angle-1 .help-inline .miter-validation-angle-invalid-error').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_ANGLE_A_RANGE :
            $('.miter-angle-1 .help-inline').removeClass("hide");
            $inputMiterAngle1.addClass("dimension-input-border");
            $('.miter-angle-1 .help-inline .miter-validation-angle-minmax-error').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_ANGLE_B_INVALID:
            $('.miter-angle-2 .help-inline').removeClass("hide");
            $inputMiterAngle2.addClass("dimension-input-border");
            $('.miter-angle-2 .help-inline .miter-validation-angle-invalid-error').removeClass("hide");
            break;
        case ACC.productMiterSawing.ERR_MITER_ANGLE_B_RANGE :
            $('.miter-angle-2 .help-inline').removeClass("hide");
            $inputMiterAngle2.addClass("dimension-input-border");
            $('.miter-angle-2 .help-inline .miter-validation-angle-minmax-error').removeClass("hide");
            break;
        default:
            $('.miter-length .help-inline').addClass("hide");
            $('.miter-length .help-inline span').addClass("hide");
            $inputMiterLength.removeClass("dimension-input-border");
            break;
    }

    // ---------- validate miter sawing ------------------------------
    if ($('#miterSawingButton').attr('data-miter-btn-state') == "selected") {

        // validate choosen miter form
        if($('#miterCarousel .miter-form.selected').length < 1) {
            $('.miter-form-error.help-inline').removeClass("hide");
            $('.miter-form-error.help-inline .custom-dimension-miterform-popup').removeClass("hide");
            popupIsValid = false;
        }
     }

    return popupIsValid;
};

ACC.productMiterSawing.prepareMiterSawingPopup = function(data) {
    // remove old jcarousel container and create a new one
    $('div.miter-forms').remove();
    $('.miter-body').prepend('<div class="miter-forms"><ul id="miterCarousel" class="jcarousel-skin-miter"></ul></div>');

    if ($('#miterSawingButton').attr('data-miter-btn-state') != 'selected') {
        $('.miter-forms').addClass('hide');
    }

    if (data) {
        // add elements to miter-forms from response
        data.types.forEach(ACC.productMiterSawing.addMiterForm);
    } else {
        ACC.productMiterSawing.addDkgMiterForm();
    }
    // start jcarousel again

    // jcarousel is only used for css and html handling
    // scrolling functionality is taken over
    $('#miterCarousel').jcarousel({
        vertical: true,
        start: 1,
        scroll: 1,
        itemFallbackDimension: 300,
    });

    // add class for standard behavior of prev and next buttons for vertical jcarousel
    $('.jcarousel-skin-miter').addClass('jcarousel-skin');

    $('.miter-forms').on("click", function (e) {
        e.preventDefault();

        var miterForm;
        if ($(e.target).hasClass('miter-form')) {
            miterForm = $(e.target);
        } else {
            miterForm = $(e.target).parents('.miter-form');
        }

        if ($(miterForm).length > 0) {
            var miterFormImg = $(miterForm).find('.miter-form-thumb').html();
            var miterFormText = $(miterForm).find('.miter-form-type span').html();

            if (!$(miterForm).hasClass('selected') && $('.miter-form').hasClass('selected')) {
                // reset value if input fields
                $('.input-miter-length').val('');
                $('.miter-tolerance .custom-dimension-tolerance-select').val($('.miter-tolerance .custom-dimension-tolerance-select option:first').val());
                $('.miter-angle-1 .input-miter-angle').val('');
                $('.miter-angle-2 .input-miter-angle').val('');
            }

            if (miterFormImg) {
                $('.miter-custom-data .miter-form-image img').remove();
                $('.miter-custom-data .miter-form-image').append(miterFormImg);
                $('.miter-custom-data .miter-form-image').removeClass('hide');
            }
            if (miterFormText) {
                $('.miter-custom-data .miter-form-name h3').remove();
                $('.miter-custom-data .miter-form-name').append('<h3>' + miterFormText + '</h3>');
                $('.miter-custom-data .miter-form-name').removeClass('hide');
            }

            var angle1 = $(miterForm).attr('data-angle-1');
            var angle2 = $(miterForm).attr('data-angle-2');
            var angle3 = $(miterForm).attr('data-angle-3');
            var angle4 = $(miterForm).attr('data-angle-4');

            var angleCount = $(miterForm).attr('data-angle-count');

            $('.miter-angle-1').addClass('hide');
            $('.miter-angle-2').addClass('hide');
            $('.miter-angle-3').addClass('hide');
            $('.miter-angle-4').addClass('hide');
            $('.miter-angle-1 .input-miter-angle').val('');
            $('.miter-angle-2 .input-miter-angle').val('');
            $('.miter-angle-3 .input-miter-angle').val('');
            $('.miter-angle-4 .input-miter-angle').val('');

            if (angleCount) {
            	if (angleCount >= "1") {
                    $('.miter-angle-1').removeClass('hide');
                }
                if (angleCount >= "2") {
                    $('.miter-angle-2').removeClass('hide');
                }
                if (angleCount >= "3") {
                    $('.miter-angle-3').removeClass('hide');
                }
                if (angleCount >= "4") {
                    $('.miter-angle-4').removeClass('hide');
                }
            }

            if (angle1 === 'true') {
            	 $('.miter-angle-1').removeClass('hide');
            }
            if (angle2 === 'true') {
           	 $('.miter-angle-2').removeClass('hide');
            }
            if (angle3 === 'true') {
           	 $('.miter-angle-3').removeClass('hide');
            }
            if (angle4 === 'true') {
           	 $('.miter-angle-4').removeClass('hide');
            }


            // remove all class select on all miter-forms and set it back to the choosen miter form element
            $('#miterCarousel .miter-form').removeClass('selected');
            $(miterForm).addClass('selected');

            $.colorbox.resize();
        }
    })
};

ACC.productMiterSawing.callMiterSawingColorBox = function(state) {
    $.colorbox({
        inline: true,
        href: ".custom-dimension-miter-wrapper",
        transition: "none",
        scrolling: false,
        innerWidth: 550,
        onLoad: function () {
            $('#cboxClose').remove();
        },
        onComplete: function () {
            ACC.productMiterSawing.showMiterPopup(state);
            ACC.productMiterSawing.initMiterFormCarousel();
            $.colorbox.resize();
        },
        onClosed: function () {
            ACC.productMiterSawing.hideMiterSawingPopup();
        }
    });
};

ACC.processing.updateProcessingInformation = function(data) {
	var options = data.availableProcessingOptions;
	var conservationOptions = data.availableConservationOptions;
	var selectedConservation = data.selectedConservationOption;
	if (!options) {
		ACC.processing.hideConservationBox();
		return;
	}
	ACC.processing.addProcessingOptions(options);
	if (conservationOptions && conservationOptions.length > 0) {
		ACC.processing.addConservationOptions(conservationOptions, selectedConservation);
    	ACC.processing.showConservationBox();
	}
	else {
		ACC.processing.hideConservationBox();
	}
}

ACC.processing.hideConservationBox = function() {
	$('.select-pdp-conservationOption-box').addClass("hide");
}

ACC.processing.showConservationBox = function() {
	$('.select-pdp-conservationOption-box').removeClass("hide");
}

ACC.processing.addConservationOptions = function(conservationOpts, selectedConservation) {
	if (!conservationOpts || !conservationOpts.length) {
		return;
	}
	if (!$('.select-pdp-conservationOption')) {
		var s = $('<select class="select-pdp-conservationOption" />');
		s.appendTo('.select-pdp-conservationOption-box');
	}
	var dropdown = $('.select-pdp-conservationOption');
	dropdown.empty();
	for (var i = 0; i < conservationOpts.length; i++) {
		var selected = selectedConservation && conservationOpts[i].id == selectedConservation;
		$('<option />', {value: conservationOpts[i].id, text: conservationOpts[i].name, selected: selected}).appendTo(dropdown);
    }
}

ACC.processing.addProcessingOptions = function(options) {
	var carouselContainer = $('#dkgMiterCarouselContentContainer');
	if (!carouselContainer) {
		return;
	}
	carouselContainer.html('');
	for (var i = 0; i < options.length; i++) {
		if (!options[i] || options[i].id == '10' || !options[i].length) {
			continue;
		}
		var hasAngle1 = options[i].angleA == true;
		var hasAngle2 = options[i].angleB == true;
		var hasAngle3 = options[i].angleC == true;
		var hasAngle4 = options[i].angleD == true;
		if (!hasAngle1 && !hasAngle2 && !hasAngle3 && !hasAngle4) {
			continue;
		}
		var processingName = options[i].name + "-" + options[i].id;
		var processingId = options[i].id;
		var processingImage = options[i].image;
		var listHTML = '<a href="#" class="miter-form" data-angle-1="' + hasAngle1 +'" data-angle-2="' + hasAngle2 +'" data-angle-3="' + hasAngle3 +'" data-angle-4="' + hasAngle4 +'" data-sawing-type="'+ processingId + '"><div class="miter-form-thumb"><img src="'+ processingImage + '"></div><div class="miter-form-type"><span>'+ processingName + '</span></div></a>';
		$('<li />').html(listHTML).appendTo(carouselContainer);
    }
}

$(document).ready(function () {
    if ($(".page-productDetails").length) {
        with (ACC.productMiterSawing) {
            setMiterSawing();
        }

        $('.js-submit-miter-on-enter').on('keydown', function (e) {
            var $this = $(this);
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                if ($this.hasClass('open')) {
                    ACC.productMiterSawing.submitMiterSawing();
                    e.preventDefault();
                    return false;
                }
            }
        });
    }
});
